import { inject } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { RoleType } from "@app/shared/enums/roles";
import { RoleService } from "@app/shared/services/role.service";


// GN Műszerfal
// GN
export const trusteelandingpageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO)  || roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// GN Takarítási feladatok
// GN
export const cleaningtaskeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// GN Takarítási feladat típusok
// GN
export const cleaningtypeeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// MV Karbantartási feladatok
// MV
export const maintenancetaskeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// MV Karbantartás feladat típusok
// GN
export const maintenancetypeeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return  hasRole
}

// Szobastátusz lista
export const roomstatelistGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) || roleService.userIsInRole(RoleType.MUSZAKOS)
    || roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO)
    || roleService.userIsInRole(RoleType.RECEPCIOS)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// Public area cleaning type editor
export const careacleaningtypeGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole

}

// Feladat beosztás
export const schedulerGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.MUSZAKI_VEZETO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// Felhasználói csoportok szerkesztése
export const usergroupeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.MUSZAKI_VEZETO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// Takarítás típus szobastátusz összerendelés
export const clearoomstateeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// Feladatok listája
export const tasklistrGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) || roleService.userIsInRole(RoleType.MUSZAKOS)
    || roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO)
    || roleService.userIsInRole(RoleType.RECEPCIOS)

  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole

}

// Felhasználói csoportok szerkesztése

export const usersettingseditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole =  roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) || roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// Hotel beállítások

export const hotelsettingseditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

// szobatípusok listája
export const roomtypeeditorGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole= roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const housekeepingsettingsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) ||  roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}


export const maintenancesettingsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) ||  roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const recepcionistlandingpageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.RECEPCIOS)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const maintenanceleaderlandingpageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) ||  roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const minibarlistGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole  = roleService.userIsInRole(RoleType.GONDNOKNO)  || roleService.userIsInRole(RoleType.RECEPCIOS) || roleService.userIsInRole(RoleType.TAKARITO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const taskschedulercalendarGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.MUSZAKI_VEZETO)
    || roleService.userIsInRole(RoleType.RECEPCIOS)

    if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const subscriberparametersGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole  = roleService.userIsInRole(RoleType.ADMIN)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const taskhistoryGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) || roleService.userIsInRole(RoleType.MUSZAKOS)
    || roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO) ||  roleService.userIsInRole(RoleType.ADMIN)
    || roleService.userIsInRole(RoleType.RECEPCIOS)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const hkreportGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO) ||  roleService.userIsInRole(RoleType.ADMIN)
    || roleService.userIsInRole(RoleType.RECEPCIOS)

  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}


export const lostandfoundGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) || roleService.userIsInRole(RoleType.MUSZAKOS)
    || roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO) ||  roleService.userIsInRole(RoleType.ADMIN)
    || roleService.userIsInRole(RoleType.RECEPCIOS)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const extratasksGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const chatGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.MUSZAKI_VEZETO) || roleService.userIsInRole(RoleType.MUSZAKOS)
    || roleService.userIsInRole(RoleType.GONDNOKNO) || roleService.userIsInRole(RoleType.TAKARITO)
    || roleService.userIsInRole(RoleType.RECEPCIOS)

  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}

export const detailedperformancereportGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree => {
  const roleService = inject(RoleService)
  const router = inject(Router)
  const hasRole = roleService.userIsInRole(RoleType.GONDNOKNO)
  if (!hasRole) {
    router.navigateByUrl('/kip/noaccessrights')
  }
  return hasRole
}







